import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import useFeatureFlags from 'hooks/useFeatureFlags';
import OnDemandPracticeRoot from './OnDemandPracticeRoot';
import OnDemandPracticeScenario from './OnDemandPracticeScenario';

const OnDemandPracticeRouter = () => {
  const hasOnDemandPractice = useFeatureFlags([
    'practice',
    'on_demand_practice',
  ]);

  const isUnifiedLearn2 = useFeatureFlags([
    'readiness-enable-unification',
    'readiness-enable-learn2',
  ]);

  const metaProps = {
    meta: {
      features: {
        on_demand_practice: hasOnDemandPractice,
        is_unified_learn2: isUnifiedLearn2,
      },
    },
  };

  return (
    <BrowserRouter>
      <Route
        path="/learning/practice/scenarios/:scenarioId"
        render={props => {
          const { scenarioId } = props.match.params;
          return (
            <OnDemandPracticeScenario scenarioId={scenarioId} {...metaProps} />
          );
        }}
      />
      <Route
        path="/preview/practice/scenarios/:scenarioId"
        render={props => {
          const { scenarioId } = props.match.params;
          return (
            <OnDemandPracticeScenario
              isPreviewing
              scenarioId={scenarioId}
              {...metaProps}
            />
          );
        }}
      />
      <Route
        path="/learning/practice/scenarios"
        exact
        render={() => <OnDemandPracticeRoot {...metaProps} />}
      />
    </BrowserRouter>
  );
};

export default OnDemandPracticeRouter;
